import { render, staticRenderFns } from "./socialLogin.vue?vue&type=template&id=679529a6"
import script from "./socialLogin.vue?vue&type=script&lang=js"
export * from "./socialLogin.vue?vue&type=script&lang=js"
import style0 from "./socialLogin.vue?vue&type=style&index=0&id=679529a6&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports